export default function Unchecked() {
    return (
        <svg
            className={`fill-current w-[1em] h-[1em] inline-block text-[1.5rem] transition-[fill] shrink-0 select-none`}
            focusable="false" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"></path>
        </svg>
    )
}